// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"a628bcfd","406":"1cbb83ee","854":"56af31d8"}[chunkId] + ".chunk.css";
};